import { DayOfTheWeek } from '@/models/DayOfTheWeek';
import { Geolocation } from '@/modules/store/models/Geolocation';
import { OrderPredictionAlgorithm } from '@/modules/store/models/OrderPrediction';
import { Status } from '@/modules/store/models/Status';

type CustomData = { [key: string]: string };
type DynamicFields = { [key: string]: string };

export enum StoreAssociation {
  RETAILER = 'retailer',
  ORGANIZATION = 'organization',
}

export interface Store {
  id: string;
  code: string;
  retailerId: string;
  name: string;
  email: string;
  customerCode: string;
  moq: number;
  externalCode?: string;
  contactCountryCode: string;
  contactNumber: string;
  description: string;
  currencyCode: string;
  status: Status;
  showVat: boolean;
  orderPrediction: StoreOrderPrediction;
  receivingWindows: StoreReceivingWindow[];
  customData: CustomData;
  dynamicFields: DynamicFields;
  organizationId: string;
  addresses: StoreAddress[];
  createdAt: Date;
}

export enum StoreAddressType {
  BUSINESS = 'business',
  BILLING = 'billing',
  DELIVERY = 'delivery',
  UNKNOWN = 'unknown',
}

export interface StoreAddress {
  id?: string;
  storeId: string;
  type: StoreAddressType;
  building: string;
  street1: string;
  street2: string;
  postalCode: string;
  region: string;
  city: string;
  countryCode: string;
  location: Geolocation;
  additionalDescription: string;
}

interface Time {
  hours: number;
  hours24: number;
  minutes: number;
  seconds: number;
  period: 'AM' | 'PM';
}

export interface StoreReceivingWindow {
  id?: string;
  storeId?: string;
  day: DayOfTheWeek;
  startTime: Time;
  endTime: Time;
}

export interface StoreOrderPrediction {
  enabled: boolean;
  algorithm?: OrderPredictionAlgorithm;
}

export interface StoreUpdate {
  id: string;
  code: string;
  retailerId: string;
  name: string;
  email: string;
  externalCode?: string;
  contactNumber: string;
  description: string;
  status: Status;
  addresses: StoreAddress[];
  receivingWindows: StoreReceivingWindow[];
  orderPrediction: StoreOrderPrediction;
  customData: CustomData;
  dynamicFields: DynamicFields;
}

export function findStoreAddress(
  addresses?: StoreAddress[],
  addressTypes: StoreAddressType[] = [StoreAddressType.BUSINESS],
): StoreAddress | undefined {
  if (!addresses) {
    return;
  }

  for (const addressType of addressTypes) {
    const address = addresses.find((item) => item.type === addressType);
    if (address) {
      return address;
    }
  }

  return;
}
